/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/04/2022
 */

import { FormLabels } from '@/wpt-lib/interfaces/FormLabels';

export const label = (labels: FormLabels['property'], field: string) => (labels ? labels[field] ?? field : field);

export const optionalLabel = (labels: FormLabels['property'], field: string | undefined, def = '') =>
    field ? label(labels, field) : def;
